export default __webpack_public_path__ + "static/media/slider-thump.858d99da.svg";